// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.phase-fixtures-resume__container {
    width: 100%;
    /* z-index: 99;
    grid-column: 3 / 13; */
    background-color: var(--white-color);
    /* border-radius: calc( var( --space ) - var( --space-eighth ) );
    margin: var( --space-and-half ) 0 0 var( --space ); */
    padding: 0 40px; 

}

/* .phase-fixtures-resume__title{
    border-bottom: 1px solid #ECECEC;
    padding-bottom: var(--space);
    margin-bottom: var( --space-and-half );
} */

.phase-fixtures-resume__counts{
    display: flex;
    justify-content: center;
}

.phase-fixtures-resume__counts .baloa-names{
    color: var(--basic-gray-color);
    margin-right: calc( var( --space-x3 ) + var( --space-and-half ) );
    text-transform: capitalize;
}

.phase-fixtures-resume__buttons{
    display: flex;
    margin: var( --space-and-half ) 0;
}

.phase-fixtures-resume__buttons-btn2{
    margin-right: var(--space-and-half);
    width: calc(var(--space)*13);
}

.phase-fixtures-resume__buttons-btn1{
    width: calc(var(--space)*13);
}

.phase-fixtures-resume__separator{
    border: 1px solid var(--mid-gray-color);    
    width: 100%;
    margin-top: var(--space);
}

.phase-fixtures-resume__groups{
    margin-bottom: 24px;    
}

.phase-fixtures-resume__group-title.baloa-subtitle-2 {
    color: var( --primary-very-dark-color );
    width: 100%;
}

.phase-fixtures-resume__date{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto;
    grid-gap: 11px;
}

.phase-fixtures-resume__date-title.baloa-names {
    margin-top: 16px;
    color: var( --primary-dark-color );
    grid-column-start: 1;
    grid-column-end: 3;
    display: inherit;
}

.phase-fixtures-resume__match{
    display: flex;
    align-items: center;
    padding: 12px 16px;
}

.phase-fixtures-resume__team{
    display: flex;
    align-items: center;
    width: 45%;
    gap: 12px
}

/* .phase-fixtures-resume__team:first-of-type {
    margin-bottom: var( --space-half-quarter );    
}
*/
.phase-fixtures-resume__team:last-of-type {
    justify-content: end; 
}

.phase-fixtures-resume__team-image{
    width: var(--space-and-half);
    height: var(--space-and-half);
    display: flex;
    align-items: center;
}

.phase-fixtures-resume__team-image img{
    width: var(--space-and-half);
    height: var(--space-and-half);
    border-radius: 50%;
}

.phase-fixtures-resume__team-image .icon-ball {
    font-size: 19px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 4px;
    color: var(--white-color);
}

.phase-fixtures-resume__team-name.baloa-username{
    color: var( --primary-very-dark-color );
}

.phase-fixtures-resume__vs.baloa-username{    
    color: var(--primary-very-dark-color);
    margin: 0 17px;
}

.phase-fixtures-resume__loader-container{
    display: flex;
    width: calc(var(--space)*14);
    height: calc(var(--space)*5);
    border-radius: var( --space-half );
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    margin-top: 200px;
    margin-bottom: 200px;
    background-color: var(--white-color);
}

.phase-fixtures-resume__loader-text.baloa-body-1{
    margin: 0 var( --space ) 0 var( --space );
    font-size: calc( var( --space ) + var( --space-eighth ) + 1px );
}

.phase-fixtures-resume__loader {
    border: 4px solid var(--basic-green-color); 
    border-top: 4px solid var(--white-color); 
    border-radius: 50%;
    max-width: calc( var( --space-and-half ) + var( --space-quarter ) );
    max-height: calc( var( --space-and-half ) + var( --space-quarter ) );
    min-width: calc( var( --space-and-half ) + var( --space-quarter ) );
    min-height: calc( var( --space-and-half ) + var( --space-quarter ) );
    animation: spin 2s linear infinite;
    margin-right: var(--space);
}
  
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.tournament-phase-fixtures-resume__warning {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px;
    border-radius: 4px;
    background-color: var(--new-informative-banner-bg-color);
    margin-top: 24px;
}

.tournament-phase-fixtures-resume__warning .baloa-username {
    font-weight: var(--font-medium);
}

.tournament-phase-fixtures-resume__warning .hubicon-info::before {
    color: var(--new-informative-banner-color);
    font-size: 18px;
}

.phase-fixtures-resume__match-container {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
    margin-top: 12px;
}

.phase-fixtures-resume__match-actions {
    border-bottom: 1px solid var(--new-gray-background-color);
    padding: 8px 16px;
    display: flex;
    justify-content: space-between;
    position: relative;
}

.phase-fixtures-resume__match-actions .hubicon-finish_date,
.phase-fixtures-resume__match-actions .hubicon-finish_date::before,
.phase-fixtures-resume__match-actions .hubicon-stadium {
    color: var(--primary-dark-color);
    font-size: 12px;
}

.phase-fixtures-resume__match-actions__action {
    align-items: center;
    display: flex;
    gap: 8px;
    justify-content: center;
}

.phase-fixtures-resume__match-actions__action .not-scheduled {
    color: var(--new-green-color);
    cursor: pointer;
}

.phase-fixtures-resume__matches {
    height: calc(100vh - 250px);
}

.phase-fixtures-resume__match-actions__action .baloa-username.match-date {
    color: var(--primary-very-dark-color);
    text-transform: capitalize;
    cursor: pointer;
}

.phase-fixtures-resume__info-edit {
    position: absolute;
    width: 370px;
    box-shadow: var(--shadow-card-1);
    border-radius: 8px;
    background-color: var(--white-color);
    top: 40px;
    left: 0px;
    display: none;
    z-index: 100;
    scale: 0;
}

.phase-fixtures-resume__info-edit.show {
    display: block;
    scale: 1;
}

.phase-fixtures-resume__info-edit__option {
    display: flex;
    align-items: baseline;
    gap: 8px;
    justify-content: center;
}`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-phase-fixture-resume/TournamentPhaseFixtureResumeComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX;0BACsB;IACtB,oCAAoC;IACpC;yDACqD;IACrD,eAAe;;AAEnB;;AAEA;;;;GAIG;;AAEH;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;IAC9B,iEAAiE;IACjE,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,iCAAiC;AACrC;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,uCAAuC;IACvC,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kCAAkC;IAClC,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV;AACJ;;AAEA;;;CAGC;AACD;IACI,oBAAoB;AACxB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,4BAA4B;IAC5B,4BAA4B;IAC5B,kCAAkC;IAClC,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,yCAAyC;IACzC,+DAA+D;AACnE;;AAEA;IACI,0CAA0C;IAC1C,wCAAwC;IACxC,kBAAkB;IAClB,mEAAmE;IACnE,oEAAoE;IACpE,mEAAmE;IACnE,oEAAoE;IACpE,kCAAkC;IAClC,0BAA0B;AAC9B;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;IACb,kBAAkB;IAClB,wDAAwD;IACxD,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yDAAyD;IACzD,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;;;IAGI,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,qCAAqC;IACrC,0BAA0B;IAC1B,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,gCAAgC;IAChC,kBAAkB;IAClB,oCAAoC;IACpC,SAAS;IACT,SAAS;IACT,aAAa;IACb,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,uBAAuB;AAC3B","sourcesContent":[".phase-fixtures-resume__container {\n    width: 100%;\n    /* z-index: 99;\n    grid-column: 3 / 13; */\n    background-color: var(--white-color);\n    /* border-radius: calc( var( --space ) - var( --space-eighth ) );\n    margin: var( --space-and-half ) 0 0 var( --space ); */\n    padding: 0 40px; \n\n}\n\n/* .phase-fixtures-resume__title{\n    border-bottom: 1px solid #ECECEC;\n    padding-bottom: var(--space);\n    margin-bottom: var( --space-and-half );\n} */\n\n.phase-fixtures-resume__counts{\n    display: flex;\n    justify-content: center;\n}\n\n.phase-fixtures-resume__counts .baloa-names{\n    color: var(--basic-gray-color);\n    margin-right: calc( var( --space-x3 ) + var( --space-and-half ) );\n    text-transform: capitalize;\n}\n\n.phase-fixtures-resume__buttons{\n    display: flex;\n    margin: var( --space-and-half ) 0;\n}\n\n.phase-fixtures-resume__buttons-btn2{\n    margin-right: var(--space-and-half);\n    width: calc(var(--space)*13);\n}\n\n.phase-fixtures-resume__buttons-btn1{\n    width: calc(var(--space)*13);\n}\n\n.phase-fixtures-resume__separator{\n    border: 1px solid var(--mid-gray-color);    \n    width: 100%;\n    margin-top: var(--space);\n}\n\n.phase-fixtures-resume__groups{\n    margin-bottom: 24px;    \n}\n\n.phase-fixtures-resume__group-title.baloa-subtitle-2 {\n    color: var( --primary-very-dark-color );\n    width: 100%;\n}\n\n.phase-fixtures-resume__date{\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: auto;\n    grid-gap: 11px;\n}\n\n.phase-fixtures-resume__date-title.baloa-names {\n    margin-top: 16px;\n    color: var( --primary-dark-color );\n    grid-column-start: 1;\n    grid-column-end: 3;\n    display: inherit;\n}\n\n.phase-fixtures-resume__match{\n    display: flex;\n    align-items: center;\n    padding: 12px 16px;\n}\n\n.phase-fixtures-resume__team{\n    display: flex;\n    align-items: center;\n    width: 45%;\n    gap: 12px\n}\n\n/* .phase-fixtures-resume__team:first-of-type {\n    margin-bottom: var( --space-half-quarter );    \n}\n*/\n.phase-fixtures-resume__team:last-of-type {\n    justify-content: end; \n}\n\n.phase-fixtures-resume__team-image{\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    display: flex;\n    align-items: center;\n}\n\n.phase-fixtures-resume__team-image img{\n    width: var(--space-and-half);\n    height: var(--space-and-half);\n    border-radius: 50%;\n}\n\n.phase-fixtures-resume__team-image .icon-ball {\n    font-size: 19px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 4px;\n    color: var(--white-color);\n}\n\n.phase-fixtures-resume__team-name.baloa-username{\n    color: var( --primary-very-dark-color );\n}\n\n.phase-fixtures-resume__vs.baloa-username{    \n    color: var(--primary-very-dark-color);\n    margin: 0 17px;\n}\n\n.phase-fixtures-resume__loader-container{\n    display: flex;\n    width: calc(var(--space)*14);\n    height: calc(var(--space)*5);\n    border-radius: var( --space-half );\n    justify-content: center;\n    align-items: center;\n    margin-left: auto;\n    margin-right: auto;\n    margin-top: 200px;\n    margin-bottom: 200px;\n    background-color: var(--white-color);\n}\n\n.phase-fixtures-resume__loader-text.baloa-body-1{\n    margin: 0 var( --space ) 0 var( --space );\n    font-size: calc( var( --space ) + var( --space-eighth ) + 1px );\n}\n\n.phase-fixtures-resume__loader {\n    border: 4px solid var(--basic-green-color); \n    border-top: 4px solid var(--white-color); \n    border-radius: 50%;\n    max-width: calc( var( --space-and-half ) + var( --space-quarter ) );\n    max-height: calc( var( --space-and-half ) + var( --space-quarter ) );\n    min-width: calc( var( --space-and-half ) + var( --space-quarter ) );\n    min-height: calc( var( --space-and-half ) + var( --space-quarter ) );\n    animation: spin 2s linear infinite;\n    margin-right: var(--space);\n}\n  \n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.tournament-phase-fixtures-resume__warning {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 10px;\n    border-radius: 4px;\n    background-color: var(--new-informative-banner-bg-color);\n    margin-top: 24px;\n}\n\n.tournament-phase-fixtures-resume__warning .baloa-username {\n    font-weight: var(--font-medium);\n}\n\n.tournament-phase-fixtures-resume__warning .hubicon-info::before {\n    color: var(--new-informative-banner-color);\n    font-size: 18px;\n}\n\n.phase-fixtures-resume__match-container {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n    margin-top: 12px;\n}\n\n.phase-fixtures-resume__match-actions {\n    border-bottom: 1px solid var(--new-gray-background-color);\n    padding: 8px 16px;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n}\n\n.phase-fixtures-resume__match-actions .hubicon-finish_date,\n.phase-fixtures-resume__match-actions .hubicon-finish_date::before,\n.phase-fixtures-resume__match-actions .hubicon-stadium {\n    color: var(--primary-dark-color);\n    font-size: 12px;\n}\n\n.phase-fixtures-resume__match-actions__action {\n    align-items: center;\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n}\n\n.phase-fixtures-resume__match-actions__action .not-scheduled {\n    color: var(--new-green-color);\n    cursor: pointer;\n}\n\n.phase-fixtures-resume__matches {\n    height: calc(100vh - 250px);\n}\n\n.phase-fixtures-resume__match-actions__action .baloa-username.match-date {\n    color: var(--primary-very-dark-color);\n    text-transform: capitalize;\n    cursor: pointer;\n}\n\n.phase-fixtures-resume__info-edit {\n    position: absolute;\n    width: 370px;\n    box-shadow: var(--shadow-card-1);\n    border-radius: 8px;\n    background-color: var(--white-color);\n    top: 40px;\n    left: 0px;\n    display: none;\n    z-index: 100;\n    scale: 0;\n}\n\n.phase-fixtures-resume__info-edit.show {\n    display: block;\n    scale: 1;\n}\n\n.phase-fixtures-resume__info-edit__option {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
